/**
 * User role values
 */
export enum UserRoleEnum {
	/**
	 * Internal system role, not assignable or used for login. Reserved for automated processes and system operations.
	 */
	SYSTEM = 'system',

	/**
	 * Platform operator role. Resolves from the platform `users` table and is
	 * the only role that may be granted platform-scoped subjects.
	 */
	PLATFORM = 'platform',

	/**
	 * Highest-level role with full access. Assigned to a single user responsible for managing all system settings and critical configurations.
	 */
	OWNER = 'owner',

	/**
	 * Administrative role with broad permissions. Intended for users who manage and maintain the system.
	 */
	ADMIN = 'admin',

	/**
	 * Standard user role with read-write access for daily operations. Assigned to regular staff members.
	 */
	BASIC = 'basic',

	/**
	 * Read-only role for users who need to view information without making changes, such as accountants or auditors.
	 */
	STAKEHOLDER = 'stakeholder',
}
